<template>
	<transition name="fade">
    <div style="z-index: 1036" >
      <div class="row no-gutters justify-content-center">
        <div class="fixed-bottom d-block nav-bottom" style="bottom:0%;top: 0">
          <div class="custom-container-fluid px-0">
            <div class="row justify-content-center no-gutters">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12">
                <div class="bg-white">
                  <div class="w-100 popup-full">
                    <div class="">
                      <loader v-if="is_load" />
								      <template v-else>
								        <div class="my-4" v-if="error != ''">
								          <ErrorMessage :message="error" />
								        </div>
								        <template v-else>
		                      <div class="w-100 position-relative" style="height: 250px !important;">
		                      	<img src="../../../../assets/img/icon/cancel.png" class="d-inline-block p-2 rounded-3 bg-back mt-3 mx-4 cursor-pointer position-absolute" width="33" style="z-index: 1049" @click="close()">
		                        <img :src="data.image_url" class="img-fit" height="250">
		                      </div>
		                      <div class="container px-4 my-2">
		                        <p class="mb-2 body-1-4 text-20">{{data.name}}</p>
	                          <p class="body-3-3 text-14 font-regular">{{data.description}}</p>
		                      </div>
								          <p class="mb-2 body-2-2 text-16 font-bold w-100 text-center">{{$t('hotel.concierge.reward-list')}}</p>
		                      <div class="container px-4 mb-2 sticky bg-white mb-4">
								            <div class="text-center w-100">
								              <div class="text-center d-inline-block cursor-pointer" v-for="(data, index) in data.module_affected" @click="changeModule(data)">
								                <p class="body-2 px-3 mb-0 py-1 text-unactive border_1 cursor-pointer text-12 bg-light-page mr-2 rounded-3" :class="{'font-bold delay bg-green text-white border-green':module_selected == data.module_slug}">{{data.module_label}}</p>
								              </div>
								            </div>
									        </div>
									        <div class="px-4" style="margin-bottom: 120px !important">
										        <div class="row slim-grid-row">
										        	<div class="col-6 mb-4" v-for="product in product_list"> 
										        		<ProductList :data="product"></ProductList>
										        	</div>
									        	</div>
									        </div>
		                      <div class="position-relative" style="z-index: 1050">
		                        <div class="row no-gutters justify-content-center">
		                          <div class="position-fixed w-100 d-block nav-bottom" style="bottom:63px !important;">
		                            <div class="custom-container-fluid px-0">
		                              <div class="row justify-content-center no-gutters">
		                                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
		                                  <div class="bg-white container px-4 w-100 py-2" style="box-shadow: rgb(236 236 236 / 48%) 0px -2px 3px;">
		                                    <button type="button" class="button-primary w-100" @click="gotoModule()">{{$t('hotel.concierge.claim-your-reward')}}</button>
		                                  </div>
		                                </div>
		                              </div>
		                            </div>
		                          </div>
		                        </div>
		                      </div>
								        </template>
								      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
	import {formatCurrency,formatDate} from '@/utils/index.js';
  import {mapGetters} from "vuex";
  import {get} from '@/services/index.js'
  import ProductList from '@/components/hotel/concierge/member/ProductList'

	export default{
		components:{
			ProductList
		},
		props: ['reward_id'],
		data(){
			return{
				is_load: false,
				error: '',
				data: {},
				module_selected: '',
				product_list: []
			}
		},
		mounted(){
			this.loadRewardDetail()
		},
		methods:{
			...mapGetters(['getMerchant']),
			close(){
				this.$emit('close')
			},
			gotoModule(){
				this.$router.push(`/${this.getMerchant().code}/concierge/${this.module_selected}`)
			},
			changeModule(data){
				this.module_selected = data.module_slug
        this.product_list = data.product_list
			},
			loadRewardDetail(){
        this.is_load = true
        this.error = ''
        get("CONCIERGE","membership/reward-detail/"+this.reward_id,{
          merchant_id: this.getMerchant().id
        }).then(response=>{
          let res = response.data
          if(res.success){
            this.data = res.data
            this.module_selected = res.data.module_affected[0].module_slug
            this.product_list = res.data.module_affected[0].product_list
          }else{
            this.error = res.message
          }
          this.is_load = false
        })
      }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/member/RewardDetail.vue